var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.568692 1.12467C0.519916 1.24641 0.49651 1.37694 0.500421 1.50854C0.504331 1.64014 0.535437 1.76896 0.591181 1.88749C0.646892 2.00595 0.725892 2.11124 0.822223 2.19791L5.31939 6.24159C5.50627 6.4098 5.74909 6.5 5.99719 6.5C6.2452 6.5 6.48814 6.40968 6.67499 6.24159L11.1705 2.19982C11.2675 2.11431 11.3474 2.01016 11.4043 1.89254C11.4618 1.77364 11.4944 1.64399 11.4993 1.51129C11.5043 1.37857 11.4814 1.24674 11.4327 1.12375C11.384 1.00081 11.3108 0.889964 11.2186 0.797013C11.1265 0.704117 11.0172 0.630887 10.8978 0.580409C10.7784 0.529946 10.6506 0.502896 10.5215 0.50022C10.3925 0.497544 10.2637 0.519271 10.1424 0.564638C10.0223 0.609554 9.91118 0.677067 9.81585 0.764444L5.99723 4.19754L2.17754 0.762659C2.08126 0.676039 1.96933 0.609477 1.84865 0.565651C1.728 0.521836 1.60018 0.501295 1.47224 0.504741C1.3443 0.508187 1.2177 0.535581 1.0995 0.585965C0.981277 0.636362 0.873054 0.709101 0.781675 0.801165C0.690244 0.89328 0.617442 1.003 0.568692 1.12467Z",
    fill: "#585B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrow);
export default __webpack_public_path__ + "static/media/bottom-arrow.df76cbc05c8ea439dfaf04be6faab5bf.svg";
export { ForwardRef as ReactComponent };